import { AsyncPipe } from '@angular/common';
import {
  AfterContentInit,
  ChangeDetectorRef,
  Component,
  HostBinding,
  OnDestroy,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { Banner, BannerType } from 'src/app/models';
import { BannerService } from 'src/app/services/banner.service';
import { ContentService } from 'src/app/services/content/content.service';
import { FullBannerComponent } from './full-banner/full-banner.component';
import { SplitBannerComponent } from './split-banner/split-banner.component';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FullBannerComponent, SplitBannerComponent, AsyncPipe],
})
export class BannerComponent implements OnInit, AfterContentInit, OnDestroy {
  private bannerService = inject(BannerService);
  private contentService = inject(ContentService);
  private cdr = inject(ChangeDetectorRef);
  private deviceService = inject(DeviceDetectorService);

  @HostBinding('class.hidden') hidden = false;

  subscription: Subscription;
  activeBanners$: Observable<Banner[]>;

  isMobile: boolean;

  constructor() {
    this.subscription = new Subscription();
  }

  ngOnInit() {
    this.isMobile = this.deviceService.isMobile();

    this.activeBanners$ = this.bannerService.getBanners(this.contentService.getMerchantId()).pipe(
      map((banners) => {
        if (!banners?.length) {
          return [];
        }

        let displayedBanners = [banners[0]];
        const type = displayedBanners[0].type;

        if (type === BannerType.Left || type === BannerType.Right) {
          const banner = this.findPartner(banners);

          if (banner) {
            displayedBanners.push(banner);
            displayedBanners = displayedBanners.sort((a, b) => b.type - a.type);
          }
        }

        return displayedBanners;
      }),
    );
  }

  ngAfterContentInit() {
    this.subscription.add(
      this.activeBanners$.subscribe((banners) => {
        if (!banners?.length) {
          this.hidden = true;
        }

        this.cdr.detectChanges();
      }),
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  private findPartner(banners: Banner[]): Banner | void {
    const type = banners[0].type;
    const oppositeType = type === BannerType.Left ? BannerType.Right : BannerType.Left;
    for (const banner of banners) {
      if (banner.type === oppositeType) {
        return banner;
      }
    }
  }
}
